import React, { useEffect, useState } from 'react';
import './bookingForm.css';
import { useDispatch, useSelector } from "react-redux";
import {
    bookingFormAction,
    calendarAction,
    dropdownAction,
    filterTypesOptionsAction,
    selectAction,
    bookingNotificationFormAction
} from "../../redux/rootReducer";
import {
    cancelBookingSagaAction,
    removeBookingSagaAction,
    updateBookingSagaAction
} from "../../redux/sagaActions";
import { BOOKING_FORM_INITIAL, SELECT_INITIAL, BOOKING_NOTIFICATION_FORM_INITIAL } from "../../redux/initialStateConstant";
import FilterSelect from "../FilterSelect/FilterSelect";
import TextareaAutosize from "react-textarea-autosize";
import { ChromePicker } from 'react-color';
import Select from "../Select/Select";
import Checkbox from "../Checkbox/Checkbox";
import CalendarOffline from "../CalendarOffline/CalendarOffline";
import remindOptions from "./remindOptions";

const BookingForm = ({ setCopyBooking }) => {
    const dispatch = useDispatch();

    const bookingForm = useSelector(state => state.bookingForm);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const dropdown = useSelector(state => state.dropdown);
    const calendar = useSelector(state => state.calendar);
    const filterTypesOptions = useSelector(state => state.filterTypesOptions);

    // Состояние colorPicker
    const [colorPicker, setColorPicker] = useState(false);
    // Состояние календаря
    const [openCalendar, setOpenCalendar] = useState(false);

    useEffect(() => {
        dispatch(filterTypesOptionsAction(subscription_types.map(elem => ({ ...elem, active: bookingForm.bound_subscriptions.includes(elem.id) }) )));
    }, [subscription_types]);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header booking__form-header">
                        {
                            bookingForm.id &&
                            <i className="booking__copy"
                               onClick={ () => {
                                   setCopyBooking(bookingForm.id);
                                   dispatch(bookingFormAction(BOOKING_FORM_INITIAL));
                                   dispatch(calendarAction({
                                       ...calendar,
                                       open: true,
                                       type: 'booking_copy'
                                   }));
                               }}
                            />
                        }
                        <i className="form__close"
                            onClick={ () => dispatch(bookingFormAction(BOOKING_FORM_INITIAL)) }
                        />
                        <div className="form__title">Групповое занятие</div>
                    </div>
                    <div className="form__field">
                        <div className="booking__color">
                            {
                                colorPicker
                                ?
                                    <ChromePicker
                                        color={ bookingForm.color || '#fff' }
                                        onChangeComplete={ color => dispatch(bookingFormAction({
                                            ...bookingForm,
                                            color: color.hex
                                        })) }
                                        className="booking__color-picker"
                                    />
                                : false
                            }
                            <div className="booking__color-description">Цвет</div>
                            <div
                                className="booking__color-template"
                                style={{ backgroundColor: bookingForm.color || '#fff' }}
                                onClick={ () => setColorPicker(!colorPicker) }
                            />
                        </div>
                        <div className="input__caption input__caption--required">Дата</div>
                        <div
                            className="input input--datepicker"
                            onClick={ event => {
                                event.preventDefault();
                                event.stopPropagation();
                                setOpenCalendar(!openCalendar);
                            } }
                        >{ bookingForm.date ? new Date(bookingForm.date).toLocaleDateString('ru-Ru') : '' }</div>
                        <CalendarOffline
                            date={ bookingForm.date }
                            handler={ date => {
                                dispatch(bookingFormAction({
                                    ...bookingForm,
                                    date
                                }));
                                setOpenCalendar(false);
                            }}
                            open={ openCalendar }
                            close={ () => setOpenCalendar(false) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Время</div>
                        <input type="time" className="input"
                            value={ bookingForm.time }
                            onChange={ event => dispatch(bookingFormAction({
                                ...bookingForm,
                                time: event.target.value
                            })) }
                        />
                    </div>
                    {
                        subscription_types.length
                            ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Тип занятия</div>
                                <Select
                                    current={ bookingForm.type.name }
                                    type={ 'types' }
                                    options={ subscription_types.filter(el => el.hide_booking !== '1') }
                                    handler={ elem => {
                                        dispatch(bookingFormAction({
                                            ...bookingForm,
                                            type: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                    smart={ false }
                                />
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Число посетителей</div>
                        <input type="text" className="input"
                            value={ bookingForm.max_users }
                            onInput={ event => dispatch(bookingFormAction({
                                ...bookingForm,
                                max_users: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Старт записи за x дней</div>
                        <Select
                            current={ bookingForm.start_registration_date.name }
                            type={ 'start_registration_date' }
                            options={ [
                                { id: '0', name: 'Без ограничений' },
                                { id: '1', name: '1' },
                                { id: '2', name: '2' },
                                { id: '3', name: '3' },
                                { id: '4', name: '4' },
                                { id: '5', name: '5' },
                                { id: '6', name: '6' },
                                { id: '7', name: '7' },
                                { id: '8', name: '8' },
                                { id: '9', name: '9' },
                                { id: '10', name: '10' },
                                { id: '11', name: '11' },
                                { id: '12', name: '12' },
                                { id: '13', name: '13' },
                                { id: '14', name: '14' }
                            ] }
                            handler={ elem => {
                                dispatch(bookingFormAction({
                                    ...bookingForm,
                                    start_registration_date: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ false }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Старт записи с</div>
                        <input type="time" className="input"
                               value={ bookingForm.start_registration_time }
                               onChange={ event => dispatch(bookingFormAction({
                                   ...bookingForm,
                                   start_registration_time: event.target.value
                               })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">За сколько часов ограничить запись</div>
                        <input type="text" className="input"
                            value={ bookingForm.finish_registration_hours }
                            onChange={ event => dispatch(bookingFormAction({
                                ...bookingForm,
                                finish_registration_hours: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ bookingForm.hide_users === 1 }
                            caption={ 'Скрыть число посетителей' }
                            handler={ () => dispatch(bookingFormAction({
                                ...bookingForm,
                                hide_users: bookingForm.hide_users === 1 ? 0 : 1
                            })) }
                        />
                        <div className="form__hint">Если будет указан этот параметр, количество посетителей будет скрыто</div>
                        <div className="form__hint">Разделение на очередь и основную запись останется</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">За сколько часов до тренировки напомнить</div>
                        <Select
                            current={ remindOptions[bookingForm.remind_datetime] || '' }
                            type={ 'remind' }
                            options={
                                [
                                    { id: '', name: remindOptions[''] },
                                    { id: '1', name: remindOptions['1'] },
                                    { id: '2', name: remindOptions['2'] },
                                    { id: '3', name: remindOptions['3'] },
                                    { id: '4', name: remindOptions['4'] },
                                    { id: '5', name: remindOptions['5'] },
                                    { id: '6', name: remindOptions['6'] },
                                    { id: '7', name: remindOptions['7'] },
                                    { id: '8', name: remindOptions['8'] },
                                    { id: '9', name: remindOptions['9'] },
                                    { id: '10', name: remindOptions['10'] },
                                    { id: '11', name: remindOptions['11'] },
                                    { id: '12', name: remindOptions['12'] },
                                    { id: '24', name: remindOptions['24'] }
                                ]
                            }
                            handler={ elem => {
                                dispatch(bookingFormAction({
                                    ...bookingForm,
                                    remind_datetime: elem.id
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ false }
                        />
                    </div>
                    {
                        subscription_coaches.length > 1
                            ?
                            <div className="form__field">
                                <div className="input__caption">Тренер</div>
                                <Select
                                    current={ bookingForm.coach.name }
                                    type={ 'coaches' }
                                    options={ subscription_coaches }
                                    handler={ elem => {
                                        dispatch(bookingFormAction({
                                            ...bookingForm,
                                            coach: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                    } }
                                    smart={ false }
                                />
                            </div>
                            : false
                    }
                    {
                        subscription_types.length
                            ?
                            <div className="form__field booking__select">
                                <div className="input__caption">Доступные для записи типы абонементов</div>
                                <FilterSelect
                                    options={ filterTypesOptions }
                                    handler={ id => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {
                                        // Меняем состояние выбранных элементов
                                        if (elem.id === id) return { ...elem, active: !elem.active };
                                        else return elem;
                                    }))) }
                                    placeholder={ 'Тип абонемента' }
                                    open={ dropdown === 'filter_types' }
                                    openHandler={ () => dispatch(dropdownAction('filter_types')) }
                                    clear={ () => dispatch(filterTypesOptionsAction(filterTypesOptions.map(elem => {

                                        if (elem.active) return { ...elem, active: !elem.active };
                                        else return elem;
                                    }))) }
                                />
                                <div className="form__hint">Если будут указаны типы абонементов, посетители смогут записаться только при наличии абонемента нужного типа. Во время записи будет списана тренировка.</div>
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="input__caption">Краткое описание</div>
                        <TextareaAutosize type="text" className="input input--textarea"
                                          onInput={ event => dispatch(bookingFormAction({
                                              ...bookingForm,
                                              name: event.target.value
                                          }))}
                                          value={ bookingForm.name }
                        />
                    </div>
                    <div className="form__field">
                        <Checkbox
                            active={ bookingForm.hide_in_app === 1 }
                            caption={ 'Скрыть в приложении' }
                            handler={ () => dispatch(bookingFormAction({
                                ...bookingForm,
                                hide_in_app: bookingForm.hide_in_app === 1 ? 0 : 1
                            })) }
                        />
                        <div className="form__hint">Если будет указан этот параметр, занятие будет скрыто из виджета и мобильного приложения</div>
                    </div>
                    <div className="form__field">
                        <div className="booking__notice"
                             onClick={ () => dispatch(bookingNotificationFormAction({
                                 ...BOOKING_NOTIFICATION_FORM_INITIAL,
                                 open: true,
                                 booking_id: bookingForm.id
                             })) }
                        >Отправить уведомления</div>
                    </div>
                    {
                        bookingForm.canceled
                            ?
                            <div className="form__field">
                                <div className="booking__cancel" onClick={ () => {
                                    // Подтверждение отмены группового занятия
                                    if (window.confirm('Вы действительно хотите восстановить занятие?')) {
                                        dispatch(cancelBookingSagaAction({ booking_id: bookingForm.id }));
                                    }
                                } }
                                >Восстановить групповое занятие</div>
                            </div>
                            :
                            <div className="form__field">
                                <div className="booking__cancel" onClick={ () => {
                                    // Подтверждение отмены группового занятия
                                    if (window.confirm('Вы действительно хотите отменить занятие?')) {
                                        dispatch(cancelBookingSagaAction({ booking_id: bookingForm.id }));
                                    }
                                } }
                                >Отменить групповое занятие</div>
                            </div>
                    }
                    <div className="form__field">
                        <div className="booking__remove" onClick={ () => {
                            // Подтверждение удаления записи
                            if (window.confirm('Вы действительно хотите удалить занятие?')) {
                                dispatch(removeBookingSagaAction({ booking_id: bookingForm.id }));
                            }
                        } }>Удалить групповое занятие</div>
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(updateBookingSagaAction({
                                id: bookingForm.id,
                                date: bookingForm.date,
                                time: bookingForm.time,
                                type: bookingForm.type.id,
                                coach: bookingForm.coach.id,
                                name: bookingForm.name,
                                max_users: bookingForm.max_users,
                                hide_users: bookingForm.hide_users,
                                bound_subscriptions: JSON.stringify(filterTypesOptions.filter(el => el.active).map(el => el.id)),
                                color: bookingForm.color,
                                remind_datetime: bookingForm.remind_datetime,
                                start_registration_date: bookingForm.start_registration_date.id,
                                start_registration_time: bookingForm.start_registration_time,
                                finish_registration_hours: bookingForm.finish_registration_hours,
                                hide_in_app: bookingForm.hide_in_app
                            })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingForm;